/*globals google*/
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ClientsFormController', ClientsFormController);


    ClientsFormController.$inject = [
        '$stateParams',
        'clientService',
        'genericDataService',
        '$filter',
        'modals',
        'ModalService',
        '$templateCache',
        '$rootScope',
        'endPoints',
        'NgMap',
        '$timeout',
        '$state',
        'notificationService',
        'simpleModalService',
        'preferences',
        'common',
        'restrictionService'
    ];


    /* jshint maxstatements:false, maxparams:false */
    function ClientsFormController(
        $stateParams,
        clientService,
        genericDataService,
        $filter,
        modals,
        ModalService,
        $templateCache,
        $rootScope,
        endPoints,
        NgMap,
        $timeout,
        $state,
        notificationService,
        simpleModalService,
        preferences,
        common,
        restrictionService) {
        /* PRIVATE VARIABLES */
        var id = $stateParams.id;

        var obraTemplate = $templateCache.get('app/views/modals/clientes/obraTemplate.html');
        var baseTemplate = $templateCache.get('app/views/modals/clientes/baseTemplate.html');
        var tarifasTemplate = $templateCache.get('app/views/modals/clientes/tarifasTemplate.html');
        var productsTemplate = $templateCache.get('app/views/modals/clientes/productsTemplate.html');
        var copyTarifasTemplate = $templateCache.get('app/views/modals/clientes/copyTarifasTemplate.html');

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.stateParams = $stateParams;
        vm.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;
        vm.client = {};
        vm.edit = false;
        vm.genericData = {
            empresas: {
                list: null,
                selected: { id: null }
            },
            aseguradoras: {
                list: null,
                selected: { id: null }
            },
            paises: {
                list: null,
                selected: { id: null }
            },
            provinces: {
                list: null,
                selected: { id: null }
            },
            poblaciones: {
                list: null,
                selected: { id: null }
            },
            tiposPago: {
                list: null,
                selected: { id: null }
            },
            contadorFac: {
                list: null,
                selected: { id: null }
            },
            formatoFac: {
                list: null,
                selected: { id: null }
            },
            tipoCliente: {
                list: [
                    { id: 0, nombre: 'Cliente' },
                    { id: 1, nombre: 'Particular' },
                    { id: 2, nombre: 'Cliente Potencial' },
                    { id: 3, nombre: 'Cía.Aseguradora' },
                ],
                selected: { id: null }
            },
            visibilidad: {
                list: [
                    { id: 0, nombre: 'Visible en terminal de datos del operario' },
                    { id: 1, nombre: 'No visible en terminal de datos del operario' }
                ],
                selected: { id: 0, nombre: 'Visible en terminal de datos del operario' }
            },
            metodoFac: {
                list: [
                    { id: 0, nombre: 'Una factura por orden/servicio' },
                    { id: 1, nombre: 'Una factura por orden/servicio (agrupar mismo expediente)' },
                    { id: 2, nombre: 'Una factura de varias ordenes/servicios' },
                    { id: 3, nombre: 'Autofacturación' },
                ],
                selected: { id: 0, nombre: 'Una factura por orden/servicio' }
            },
            impuestos: {
                list: [
                    { id: 0, nombre: 'Aplicar el del producto' },
                    { id: 1, nombre: 'Exento' }
                ],
                selected: { id: 0, nombre: 'Aplicar el del producto' }
            },
            tipoCobro: {
                list: [
                    { id: 0, nombre: 'A la entrega' },
                    { id: 1, nombre: 'A la retirada' },
                    { id: 2, nombre: 'Crédito' }
                ],
                selected: { id: null }
            },
            productos: {
                list: null,
                selected: { id: null }
            }
        };
        vm.dates = {
            contrato: null
        };

        vm.textInput = '';

        vm.isTarifaForm = false;

        /* PUBLIC FUNCTIONS */
        vm.onPaisChange = onPaisChange;
        vm.onProvChange = onProvChange;
        vm.baseModal = baseModal;
        vm.addBase = addBase;
        vm.editBase = editBase;
        vm.removeBase = removeBase;
        vm.obraModal = obraModal;
        vm.addObra = addObra;
        vm.removeObra = removeObra;
        vm.save = save;
        vm.createCuentaPortal = createCuentaPortal;
        vm.createAseguradoraConexionPendiente = createAseguradoraConexionPendiente;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.copyTarifaModal = tarifaModalCopy;
        vm.productModal = productModal;
        vm.effectClass = effectClass;
        vm.changeStatus = changeStatus;
        vm.onCompanyChange = onCompanyChange;
        vm.resizable = resizable;
        vm.operationsList = operationsList;


        vm.hasCuentaPortalTab = false;
        vm.showCuentaExistsBox = false;
        vm.showSendBox = false;
        vm.cuentaPortalState = 0; // 0 = no tiene aseg conex para este proveedor , 1 = tiene aseg conex sin confirmar, 2 = tiene aseg conex confirmada.


        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];
        vm.tarifaList = [];
        vm.estado = {
            null: 'Estado del cliente',
            0: 'Activo',
            1: 'Baja',
            colors: {
                0: 'green',
                2: 'black'
            }
        };
        vm.entidades = [];

        vm.getCuentaEmail = getCuentaEmail;

        /* INITIALIZER */
        (function () {
            clientService.getEntidades(preferences.prefs.sector)
                .then(function (res) {
                    vm.entidadesById = {};
                    vm.entidades = [];
                    res.forEach(e => {
                        /*CHAPUZA para que funcione Valoración/Tarifas con Traslados*/
                        if (e.entidadId.toString().toLowerCase() != 'fb29681b-861f-4e20-9a80-183eeb0a89e2') {
                            // DEFAULT
                        } else {
                            // CHAPUZA
                            e = { entidadId: '224940b1-91fb-4f01-8015-1774254fabc3', descripcionPlural: 'Órdenes de Traslados' };
                        }
                        /*CHAPUZA para que funcione Valoración/Tarifas con Traslados*/

                        vm.entidadesById[e.entidadId] = e;
                        vm.entidades.push({ id: e.entidadId, nombre: e.descripcionPlural });
                    });
                });


            //Edit
            if (id != null) {
                vm.hasCuentaPortalTab = true;
                vm.edit = true;
                clientService.getClient(id)
                    .then(function (client) {
                        //if (!common.isNullOrUndefined(client.cuentaPortal)) {
                        //	for (var i = 0; i < client.cuentaPortal.aseguradorasConexion.length; ++i) {
                        //		if (client.cuentaPortal.aseguradorasConexion[i].empresaId == client.empresaId) {
                        //			vm.cuentaPortalState = client.cuentaPortal.aseguradorasConexion[i].estado;
                        //			break;
                        //		}
                        //	}
                        //}
                        vm.cuentaPortalState = client.estadoPortal;
                        if (vm.cuentaPortalState == 1)
                            vm.showSendBox = true;

                        vm.client = client;
                        // console.log(vm.client);
                        setDates();
                        setCombosInitialData();
                    });
            }

            //New
            else {
                vm.changeStatus(null);
                vm.genericData.tipoCliente.selected = vm.genericData.tipoCliente.list[0];
            }
            if (vm.client.estado == null) vm.client.estado = 0;
            getFields();
            //Wait for the next digest cycle for the page to render so onChange events can trigger
            $timeout(function () { getGenericData(); }, 0);
        })();


        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'El cliente se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function sendEmailSentNotification() {
            notificationService.sendAppNotification({
                message: 'Se le ha enviado un correo con la solicitud al cliente.',
                positionY: 'top', positionX: 'right', delay: 4000, type: 'info'
            });
        }

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'El campo nombre es obligatorios',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        function sendErrorRequireCuenta() {
            notificationService.sendAppNotification({
                message: 'Para dar de alta una cuenta en el portal de cliente deben estar rellenados tanto el CIF como el Email',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        function sendErrorCuentaExistsForThisProvider() {
            notificationService.sendAppNotification({
                message: 'Se ha detectado que para este cliente y este proveedor ya existe una cuenta portal. No se pueden dar de alta más.',
                positionY: 'top', positionX: 'right', delay: 6000, type: 'error'
            });
        }

        function changeStatus(status) {
            vm.client.estado = status;
        }

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            var action = 'saveAndNew';
            doSave(action);
        }

        function getFields() {
            clientService.getTarifaFields(id).then(function (result) {
                var fields = [];
                vm.filterData = {};
                result.data.forEach(f => {
                    fields.push({ id: f.fieldId, nombre: clientService.fieldNames[f.fieldId] });
                    vm.filterData[f.fieldId] = f;
                    vm.filterData[f.fieldId].nombre = clientService.fieldNames[f.fieldId];
                });
                vm.fields = fields;
            });
        }

        function operationsList(fieldId) {
            if (!fieldId) { return []; }
            var type = vm.filterData[fieldId].type;
            return clientService.operations[type];
        }

        function getCuentaEmail() {
            return vm.client.cuentaPortal.usuariosPortal[0].email;
        }

        /* FUNCTION DEFINITIONS */
        function doSave(action) {
            if (vm.edit == true) {
                if (!restrictionService.hasPermission(4, 'cliente')) return;
            } else {
                if (!restrictionService.hasPermission(1, 'cliente')) return;
            }
            /*jshint maxcomplexity:false */
            // if (common.isNullOrUndefined(vm.client.id)) { sendErrorRequire(); return; }

            if (common.isNullOrUndefined(vm.client.nombre)) { sendErrorRequire(); return; }

            if (vm.genericData.empresas.selected.id) { vm.client.empresaId = vm.genericData.empresas.selected.id; }

            if (vm.genericData.paises.selected.id) {
                vm.client.pais = vm.genericData.paises.selected.id;
            }
            if (vm.genericData.provinces.selected.id) {
                vm.client.provincia = vm.genericData.provinces.selected.id;
            }
            if (vm.genericData.poblaciones.selected.id) {
                vm.client.poblacion = vm.genericData.poblaciones.selected.id;
            }

            if (vm.genericData.contadorFac.selected.id) {
                vm.client.contadorfacId = vm.genericData.contadorFac.selected.id;
            }
            if (vm.genericData.formatoFac.selected.id) {
                vm.client.formatofacturaId = vm.genericData.formatoFac.selected.id;
            }
            if (vm.genericData.tiposPago.selected.id) {
                vm.client.tipopagoId = vm.genericData.tiposPago.selected.id;
            }
            if (!common.isNullOrUndefined(vm.genericData.tipoCliente.selected.id)) {
                vm.client.tipoClienteId = vm.genericData.tipoCliente.selected.id;
                if (vm.client.tipoClienteId == 3) vm.client.aseguradoraId = vm.genericData.aseguradoras.selected.id;
                else { vm.client.aseguradoraId = null; }
            }
            if (vm.genericData.visibilidad.selected.id) {
                vm.client.visibilidad = vm.genericData.visibilidad.selected.id;
            }
            if (vm.genericData.metodoFac.selected.id) {
                vm.client.metodofacturaId = vm.genericData.metodoFac.selected.id;
            }
            if (vm.genericData.impuestos.selected.id) {
                vm.client.impuestoaplId = vm.genericData.impuestos.selected.id;
            }


            vm.client.clientepagaen = vm.genericData.tipoCobro.selected.id;


            vm.client.fechacontrato = vm.dates.contrato;
            clientService.addClient(vm.client, vm.tarifaList).then(function (clienteSave) {
                sendSAveNotification();
                vm.edit = true;
                if (action === 'saveAndClose') {
                    $state.go('flota.clientes.listado');
                }
                else if (action === 'saveAndNew') {
                    $state.go('flota.clientes.nuevo', { 'accion': 'saveAndNew' });
                }
                else {
                    vm.client.id = clienteSave.id;
                    vm.client.clienteId = clienteSave.clienteId;
                }
                vm.hasCuentaPortalTab = true;
            });

        }

        function createCuentaPortal() {
            if (common.isNullOrUndefined(vm.client.nif) || common.isNullOrUndefined(vm.client.email)) {
                sendErrorRequireCuenta();
                return;
            }

            clientService.addCuentaPortal(vm.client.nif, vm.client.email, vm.client.empresaId, vm.client.aseguradoraId, vm.client.clienteId, vm.genericData.empresas.selected.nombre).then(function (result) {

                if (result.estado == 2) {
                    sendErrorCuentaExistsForThisProvider();
                }
                else if (result.estado == 1) {
                    //vm.showCuentaExistsBox = true;
                    simpleModalService.yesNoModal('Confirmación solicitar', 'Este cliente ya tiene una cuenta en el portal. Si quiere añadirle como proveedor deberá solicitárselo directamente. ¿Desea realizar la solicitud ahora?', 'Enviar')
                        .then(function (result) {
                            if (result) {
                                vm.createAseguradoraConexionPendiente();
                            }
                        });
                    vm.client.cuentaId = result.cuentaId;
                }
                else {
                    sendEmailSentNotification();
                    vm.cuentaPortalState = 1;
                }
            });
        }

        function createAseguradoraConexionPendiente() {
            clientService.addAseguradoraConexionPendiente(vm.client.nif, vm.client.email, vm.client.empresaId, vm.client.aseguradoraId, vm.client.cuentaId, vm.client.clienteId).then(function (result) {
                if (result) {
                    sendEmailSentNotification();
                    vm.cuentaPortalState = 1;
                }
            });
        }

        function baseModal(cb, index) {
            ModalService.showModal({
                template: baseTemplate,
                controller:
                    function ($scope, close) {
                        $scope.vm = vm;
                        var edit = false;
                        var indexToModify = index;
                        $scope.name = null;
                        $scope.id = null;
                        $scope.bases = {
                            list: null,
                            //selected: { id: -1, nombre: 'Nueva base' }
                            selected: { id: null, nombre: '' }
                        };
                        $scope.sucursales = {
                            list: null,
                            //selected: { id: -1, nombre: 'Nueva base' }
                            selected: { id: null, nombre: '' }
                        };


                        if (cb) {
                            edit = true;
                            $scope.name = cb.base.nombre;
                            $scope.id = cb.base.id;
                            $scope.bases.selected = { id: cb.base.baseId, nombre: cb.base.nombre };
                            if (cb.colaboradorAseguradora) {
                                $scope.sucursales.selected = {
                                    id: cb.colaboradorAseguradora.colaboradorAseguradoraId,
                                    nombre: cb.colaboradorAseguradora.nomSucursal
                                };
                            }

                        }

                        (function () {
                            $scope.bases.loading = true;
                            genericDataService.getBases().then(function (data) {
                                $scope.bases.list = data;
                                //$scope.bases.list.unshift({ id: -1, nombre: 'Nueva base' });
                                $scope.bases.loading = false;
                            });
                        })();

                        (function () {
                            $scope.sucursales.loading = true;
                            genericDataService.getSucursales(vm.client.clienteId).then(function (data) {
                                $scope.sucursales.list = data;
                                $scope.sucursales.loading = false;
                            });
                        })();

                        $scope.save = function () {
                            if (edit) {
                                edit = false;
                                vm.editBase({
                                    nombre: $scope.bases.selected.nombre,
                                    id: $scope.bases.selected.id
                                }, {
                                        nomSucursal: $scope.sucursales.selected.nombre,
                                        colaboradorAseguradoraId: $scope.sucursales.selected.id
                                    }, indexToModify);
                            } else {
                                vm.addBase({
                                    nombre: $scope.bases.selected.nombre,
                                    baseId: $scope.bases.selected.id
                                }, {
                                        nomSucursal: $scope.sucursales.selected.nombre,
                                        colaboradorAseguradoraId: $scope.sucursales.selected.id
                                    });

                            }

                            $scope.cancel();
                        };

                        $scope.cancel = function () {
                            $rootScope.blurry = false;
                            close();
                        };
                    }
            });
        }

        function editBase(base, colaboradorAseguradora, indexToModify) {
            vm.client.clientesBases[indexToModify].base = base;
            vm.client.clientesBases[indexToModify].baseId = base.id;
            if (colaboradorAseguradora) {
                vm.client.clientesBases[indexToModify].colaboradorAseguradoraId =
                    colaboradorAseguradora.colaboradorAseguradoraId;
                if (colaboradorAseguradora.colaboradorAseguradoraId) {
                    vm.client.clientesBases[indexToModify].colaboradorAseguradora = colaboradorAseguradora;
                }
                else {
                    vm.client.clientesBases[indexToModify].colaboradorAseguradora = null;

                }
            }
        }

        function addBase(base, colaboradorAseguradora) {
            if (colaboradorAseguradora.colaboradorAseguradoraId) {
                vm.client.clientesBases.push({
                    clienteId: vm.client.clienteId,
                    base: base,
                    colaboradorAseguradora: colaboradorAseguradora,
                    colaboradorAseguradoraId: colaboradorAseguradora.colaboradorAseguradoraId
                });
            }
            else {
                vm.client.clientesBases.push({
                    clienteId: vm.client.clienteId,
                    base: base,
                    colaboradorAseguradora: null,
                    colaboradorAseguradoraId: null
                });
            }

        }

        function removeBase(index) {
            simpleModalService.yesNoModal('Confirmación', '¿Desea eliminar la base?')
                .then(function (result) {
                    if (result) {
                        if (index >= 0) {
                            vm.client.clientesBases.splice(index, 1);
                        }
                    }
                });
        }

        function obraModal(obra) {
            ModalService.showModal({
                template: obraTemplate,
                controller:
                    function ($scope, close) {
                        $scope.vm = vm;

                        $scope.newObra = {};

                        $scope.paisSelected = { id: null };
                        $scope.provinces = {
                            list: null,
                            selected: { id: null }
                        };
                        $scope.poblaciones = {
                            list: null,
                            selected: { id: null }
                        };

                        if (obra) {
                            Object.assign($scope.newObra, obra);
                            $scope.paisSelected.nombre = obra.pais;
                            $scope.provinces.selected.nombre = obra.provincia;
                            $scope.poblaciones.selected.nombre = obra.poblacion;
                        }

                        centerMap();

                        $scope.getProvincias = getProvincias;
                        $scope.getPoblaciones = getPoblaciones;
                        $scope.onPaisChange = onPaisChange;
                        $scope.onProvChange = onProvChange;
                        $scope.save = save;
                        $scope.centerMap = centerMap;
                        $scope.addZona = addZona;

                        function addZona() {
                            $scope.newObra.zona = {
                                radio: 100
                            };
                            $timeout(function () {
                                $scope.centerMap();
                            }, 0
                            );
                        }
                        function centerMap() {
                            NgMap.getMap('mapZone').then(function (map) {
                                $scope.google.maps.event.trigger(map, 'resize');
                                if (!$scope.newObra.latitud || !$scope.newObra.longitud) {
                                    map.setCenter({ lat: 40.4168, lng: -3.7038 });
                                    map.setZoom(6);
                                } else {
                                    map.setCenter({ lat: $scope.newObra.latitud, lng: $scope.newObra.longitud });
                                    map.setZoom(17);
                                }
                            });
                        }

                        function onPaisChange() {
                            var pais = $scope.paisSelected && $scope.paisSelected.id;
                            getProvincias(pais);
                        }
                        function onProvChange() {
                            var prov = $scope.provinces.selected && $scope.provinces.selected.id;
                            getPoblaciones(prov);
                        }

                        // Get the delivery provinces data -> DEPENDS ON: country
                        function getProvincias(pais) {
                            if (pais == null) {
                                $scope.provinces.list = null;
                                if ($scope.provinces.selected.id != null) {
                                    $scope.provinces.selected = { id: null, nombre: null };
                                }
                            } else {
                                $scope.provinces.loading = true;
                                genericDataService.getProvinces(id, pais)
                                    .then(function (res) {
                                        $scope.provinces.loading = false;
                                        $scope.provinces.list = res;
                                        selectChanged($scope.provinces.list,
                                            $scope.provinces.selected, false);
                                    });
                            }
                        }

                        // Get the delivery populations data -> DEPENDS ON: province
                        function getPoblaciones(provincia) {
                            if (provincia == null) {
                                $scope.poblaciones.list = null;
                                if ($scope.poblaciones.id != null) {
                                    $scope.poblaciones = { id: null, nombre: null };
                                }
                            }
                            else {
                                $scope.poblaciones.loading = true;
                                genericDataService.getPopulations(id, provincia)
                                    .then(function (res) {
                                        $scope.poblaciones.loading = false;
                                        $scope.poblaciones.list = res;
                                        selectChanged($scope.poblaciones.list,
                                            $scope.poblaciones.selected, false);
                                    });
                            }
                        }

                        function save() {
                            $scope.newObra.pais = $scope.paisSelected.nombre;
                            $scope.newObra.provincia = $scope.provinces.selected.nombre;
                            $scope.newObra.poblacion = $scope.poblaciones.selected.nombre;
                            if (obra) {
                                Object.assign(obra, $scope.newObra);
                            } else {
                                vm.addObra($scope.newObra);
                            }
                            $scope.cancel();
                        }

                        $scope.cancel = function () {
                            $rootScope.blurry = false;
                            close();
                        };
                    }
            });
        }

        function addObra(obra) {
            if (common.isNullOrUndefined(vm.client.obras))
                vm.client.obras = [];

            common.changeNulltoBlank(obra);
            vm.client.obras.push(obra);
        }

        function removeObra(index) {
            simpleModalService.yesNoModal('Confirmación', '¿Desea eliminar la base?')
                .then(function (result) {
                    if (result) {
                        if (index >= 0) {
                            vm.client.obras.splice(index, 1);
                        }
                    }
                });
        }

        vm.tarifa = {
            tarifaProductos: []
        };


        vm.andType = 'string';
        vm.andOperations = [];
        vm.andOptions = [];

        vm.orType = 'string';
        vm.orOperations = [];
        vm.orOptions = [];

        vm.newAndCondition = {};
        vm.newOrCondition = {};

        vm.andConditions = [];
        vm.orConditions = [];

        vm.productoAdd = {};
        vm.productList = [];

        vm.addAndCondition = function () {

            var condition = {
                field: vm.newAndCondition.field,
                operation: vm.newAndCondition.operation,
                value: vm.newAndCondition.value,
                type: vm.filterData[vm.newAndCondition.field.id].type
            };
            vm.andConditions.push(condition);
        };
        vm.removeAndCondition = function (index) {
            vm.andConditions.splice(index, 1);
        };

        vm.addOrCondition = function () {
            var condition = {
                field: vm.newOrCondition.field,
                operation: vm.newOrCondition.operation,
                value: vm.newOrCondition.value,
                type: vm.filterData[vm.newOrCondition.field.id].type
            };
            vm.orConditions.push(condition);
        };
        vm.removeOrCondition = function (index) {
            vm.orConditions.splice(index, 1);
        };

        vm.onAndConditionFieldChange = function (field) {
            if (common.isNullOrUndefined(field) || common.isNullOrUndefined(field.id)) {
                vm.andOperations = null;
                vm.andOptions = null;
                vm.newAndCondition = {};
                return;
            }

            var type = vm.filterData[field.id].type;
            vm.andOperations = clientService.operations[type];
            vm.newAndCondition.operation = vm.andOperations[0];

            if (type === 'options') {
                vm.andOptions = vm.filterData[field.id].options;
            }

        };
        vm.onOrConditionFieldChange = function (field) {
            if (common.isNullOrUndefined(field) || common.isNullOrUndefined(field.id)) {
                vm.orOperations = null;
                vm.orOptions = null;
                vm.newOrCondition = {};
                return;
            }

            var type = vm.filterData[field.id].type;
            vm.orOperations = clientService.operations[type];
            vm.newOrCondition.operation = vm.orOperations[0];

            if (type === 'options') {
                vm.orOptions = vm.filterData[field.id].options;
            }
        };

        vm.addProducto = function () {
            if (!vm.genericData.productos.selected.id || (!vm.productoAdd.porcentaje && !vm.productoAdd.precio)) {
                return;
            }

            var prod = {
                productoId: vm.genericData.productos.selected.id,
                descripcion: vm.genericData.productos.selected.nombre,
                metodocalculo: vm.genericData.productos.selected.metodo
            };

            var tProd = {
                metodocalculo: vm.genericData.productos.selected.metodo,
                porcentaje: vm.productoAdd.porcentaje,
                precio: vm.productoAdd.precio,
                tarifaId: vm.tarifa.tarifaId,
                producto: prod,
                productoId: prod.productoId
            };
            vm.tarifa.tarifaProductos.push(tProd);

            vm.genericData.productos.selected = null;
            vm.productoAdd = {};
        };

        vm.removeProduct = function (index) {
            vm.tarifa.tarifaProductos.splice(index, 1);
        };

        vm.addTarifa = function () {
            var andConds = vm.andConditions.map(function (cond) {
                return {
                    field: cond.field.id,
                    operation: cond.operation.id,
                    value: cond.value.id || cond.value
                };
            });
            var orConds = vm.orConditions.map(function (cond) {
                return {
                    field: cond.field.id,
                    operation: cond.operation.id,
                    value: cond.value.id || cond.value
                };
            });


            var t = vm.tarifaList.filter(obj => {
                return obj.tarifa.descripcion === vm.tarifa.descripcion;
            });

            if (t[0]) {
                t[0].tarifa = vm.tarifa;
                t[0].andConditions = andConds;
                t[0].orConditions = orConds;
            } else {
                vm.tarifaList.push({
                    tarifa: vm.tarifa,
                    andConditions: andConds,
                    orConditions: orConds
                });
            }

            var tc = vm.client.tarifasCliente.filter(obj => {
                return obj.tarifa.descripcion === vm.tarifa.descripcion;
            });

            if (tc[0]) {
                tc[0].tarifa = vm.tarifa;
            }
            else {
                vm.client.tarifasCliente.push({
                    tarifa: vm.tarifa
                });
            }

            vm.resetTarifaForm();
        };


        vm.openTarifa = function (tar) {
            vm.resetTarifaForm();

            var t = vm.tarifaList.filter(obj => {
                return obj.tarifa.descripcion === tar.descripcion;
            });

            if (t[0]) {
                vm.tarifa = t[0].tarifa;
                vm.andConditions = t[0].andConditions.map(function (cond) {
                    var field = vm.filterData[cond.field];
                    var ops = clientService.operations[field.type];
                    return {
                        field: { nombre: field.nombre, id: cond.field },
                        operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                        value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                        type: field.type
                    };
                });
                vm.orConditions = t[0].orConditions.map(function (cond) {
                    var field = vm.filterData[cond.field];
                    var ops = clientService.operations[field.type];
                    return {
                        field: { nombre: field.nombre, id: cond.field },
                        operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                        value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                        type: field.type
                    };
                });
            }
            else {
                clientService.getTarifa(tar.tarifaId).then(function (tarifa) {
                    vm.tarifa = tarifa.tarifa;

                    vm.andConditions = tarifa.andConditions.map(function (cond) {
                        var field = vm.filterData[cond.field];
                        var ops = clientService.operations[field.type];
                        return {
                            field: { nombre: field.nombre, id: cond.field },
                            operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                            value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                            type: field.type
                        };
                    });
                    vm.orConditions = tarifa.orConditions.map(function (cond) {
                        var field = vm.filterData[cond.field];
                        var ops = clientService.operations[field.type];
                        return {
                            field: { nombre: field.nombre, id: cond.field },
                            operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                            value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                            type: field.type
                        };
                    });

                });
            }

            vm.isTarifaForm = true;
        };

        function findOpById(operations, id) {
            var result = operations.filter(obj => {
                return obj.id === id;
            });
            return result[0] || null;
        }

        vm.desasignarTarifa = function (tar, index) {
            vm.client.tarifasCliente.splice(index, 1);
        }

        vm.resetTarifaForm = function () {
            vm.tarifa = {
                tarifaProductos: []
            };

            vm.andType = 'string';
            vm.andOperations = [];
            vm.andOptions = [];

            vm.orType = 'string';
            vm.orOperations = [];
            vm.orOptions = [];

            vm.newAndCondition = {};
            vm.newOrCondition = {};

            vm.andConditions = [];
            vm.orConditions = [];

            vm.productoAdd = {};
            vm.productList = [];
        };

        function tarifaModalCopy() {
            ModalService.showModal({
                template: copyTarifasTemplate,
                controller:
                    function ($scope, close) {
                        $scope.vm = vm;
                        $scope.name = null;
                        $scope.id = null;
                        $scope.save = function () {
                            $scope.cancel();
                        };
                        $scope.cancel = function () {
                            $rootScope.blurry = false;
                            close();
                        };
                    }
            });
        }

        function productModal() {
            ModalService.showModal({
                template: productsTemplate,
                controller:
                    function ($scope, close) {
                        $scope.vm = vm;
                        $scope.name = null;
                        $scope.id = null;
                        $scope.save = function () {
                            $scope.cancel();
                        };
                        $scope.cancel = function () {
                            $rootScope.blurry = false;
                            close();
                        };
                    }
            });
        }

        function onPaisChange() {
            var pais = vm.genericData.paises.selected && vm.genericData.paises.selected.id;
            getProvincias(pais);
        }
        function onProvChange() {
            var prov = vm.genericData.provinces.selected && vm.genericData.provinces.selected.id;
            getPoblaciones(prov);
        }

        /* PRIVATE FUNCTIONS */
        function getGenericData() {

            vm.genericData.paises.loading = true;
            genericDataService.getPaises(id)
                .then(function (res) {
                    vm.genericData.paises.loading = false;
                    vm.genericData.paises.list = res;
                    selectChanged(vm.genericData.paises.list, vm.genericData.paises.selected, false);
                });

            vm.genericData.aseguradoras.loading = true;
            genericDataService.getAseguradoras()
                .then(function (res) {
                    vm.genericData.aseguradoras.loading = false;
                    vm.genericData.aseguradoras.list = res;
                    selectChanged(vm.genericData.aseguradoras.list, vm.genericData.aseguradoras.selected, false);
                    if (vm.edit == false || vm.client.aseguradoraId == null) {
                        vm.genericData.aseguradoras.selected = vm.genericData.aseguradoras.list[0];
                    }
                });

            vm.genericData.empresas.loading = true;
            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;
                    selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected, false);
                    var modelEmpresas = findByProperty(vm.genericData.empresas.list, 'id', vm.client.empresaId);
                    if (modelEmpresas) {
                        vm.genericData.empresas.selected = modelEmpresas;
                    }
                    else {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                    }
                });

            vm.genericData.productos.loading = true;
            genericDataService.getProductos()
                .then(function (res) {
                    vm.genericData.productos.loading = false;
                    vm.genericData.productos.list = res;
                    selectChanged(vm.genericData.productos.list, vm.genericData.productos.selected, false);
                });

            vm.genericData.contadorFac.loading = true;
            vm.genericData.contadorFac.selected = { id: null };
            genericDataService.getContadores(vm.client.empresaId)
                .then(function (res) {
                    vm.genericData.contadorFac.loading = false;
                    vm.genericData.contadorFac.list = res;
                    selectChanged(vm.genericData.contadorFac.list, vm.genericData.contadorFac.selected, false);
                    var contadorFac = findByProperty(vm.genericData.contadorFac.list, 'id', vm.client.contadorfacId);
                    if (contadorFac) {
                        vm.genericData.contadorFac.selected = contadorFac;
                    }
                    else {
                        vm.genericData.contadorFac.selected = vm.genericData.contadorFac.list[0];
                    }
                });



            vm.genericData.formatoFac.loading = true;
            genericDataService.getInformes()
                .then(function (res) {
                    vm.genericData.formatoFac.loading = false;
                    vm.genericData.formatoFac.list = res;
                    selectChanged(vm.genericData.formatoFac.list, vm.genericData.formatoFac.selected, false);
                });

            vm.genericData.tiposPago.loading = true;
            genericDataService.getTiposPago()
                .then(function (res) {
                    vm.genericData.tiposPago.loading = false;
                    vm.genericData.tiposPago.list = res;
                    selectChanged(vm.genericData.tiposPago.list, vm.genericData.tiposPago.selected, false);
                });
        }

        // Get the delivery provinces data -> DEPENDS ON: country
        function getProvincias(pais) {
            if (pais == null) {
                vm.genericData.provinces.list = null;
                if (vm.genericData.provinces.selected.id != null) {
                    vm.genericData.provinces.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.provinces.loading = true;
                genericDataService.getProvinces(id, pais)
                    .then(function (res) {
                        vm.genericData.provinces.loading = false;
                        vm.genericData.provinces.list = res;
                        selectChanged(vm.genericData.provinces.list,
                            vm.genericData.provinces.selected, false);
                    });
            }
        }

        // Get the delivery populations data -> DEPENDS ON: province
        function getPoblaciones(provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.list = null;
                if (vm.genericData.poblaciones.selected.id != null) {
                    vm.genericData.poblaciones.selected = { id: null, nombre: null };
                }
            }
            else {
                vm.genericData.poblaciones.loading = true;
                genericDataService.getPopulations(id, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.loading = false;
                        vm.genericData.poblaciones.list = res;
                        selectChanged(vm.genericData.poblaciones.list,
                            vm.genericData.poblaciones.selected, false);
                    });
            }
        }

        function onCompanyChange() {
            var c = vm.genericData.empresas.selected && vm.genericData.empresas.selected.id;
            getContadores(c);
        }

        function getContadores(company) {
            if (company == null) { vm.genericData.contadorFac.list = null; }
            else {
                vm.genericData.contadorFac.loading = true;
                vm.genericData.contadorFac.selected = { id: null };
                genericDataService.getContadores(company)
                    .then(function (res) {
                        vm.genericData.contadorFac.loading = false;
                        vm.genericData.contadorFac.list = res;
                        selectChanged(vm.genericData.contadorFac.list, vm.genericData.contadorFac.selected);
                        var contadorFac = findByProperty(
                            vm.genericData.contadorFac.list,
                            'id',
                            vm.client.contadorfacId);
                        if (contadorFac) {
                            vm.genericData.contadorFac.selected = contadorFac;
                        }
                        else {
                            vm.genericData.contadorFac.selected = vm.genericData.contadorFac.list[0];
                        }
                    });
            }
        }

        //Valor inicial selects y combos
        function setCombosInitialData() {
            vm.genericData.paises.selected = { nombre: vm.client.pais, id: null };
            selectChanged(vm.genericData.paises.list, vm.genericData.paises.selected, false);
            vm.genericData.provinces.selected = { nombre: vm.client.provincia, id: null };
            selectChanged(vm.genericData.provinces.list, vm.genericData.provinces.selected, false);
            vm.genericData.poblaciones.selected = { nombre: vm.client.poblacion, id: null };
            selectChanged(vm.genericData.poblaciones.list, vm.genericData.poblaciones.selected, false);

            vm.genericData.empresas.selected = { nombre: null, id: vm.client.empresaId };
            selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);

            vm.genericData.aseguradoras.selected = { nombre: null, id: vm.client.aseguradoraId };
            selectChanged(vm.genericData.aseguradoras.list, vm.genericData.aseguradoras.selected);

            vm.genericData.contadorFac.selected = { nombre: null, id: vm.client.contadorfacId };
            selectChanged(vm.genericData.contadorFac.list, vm.genericData.contadorFac.selected);

            vm.genericData.formatoFac.selected = { nombre: null, id: vm.client.formatofacturaId };
            selectChanged(vm.genericData.formatoFac.list, vm.genericData.formatoFac.selected);

            vm.genericData.tiposPago.selected = { nombre: null, id: vm.client.tipopagoId };
            selectChanged(vm.genericData.tiposPago.list, vm.genericData.tiposPago.selected);

            vm.genericData.tipoCliente.selected = { nombre: null, id: vm.client.tipoClienteId };
            selectChanged(vm.genericData.tipoCliente.list, vm.genericData.tipoCliente.selected);
            vm.genericData.visibilidad.selected = { nombre: null, id: vm.client.visibilidad };
            selectChanged(vm.genericData.visibilidad.list, vm.genericData.visibilidad.selected);
            vm.genericData.metodoFac.selected = { nombre: null, id: vm.client.metodofacturaId };
            selectChanged(vm.genericData.metodoFac.list, vm.genericData.metodoFac.selected);
            vm.genericData.impuestos.selected = { nombre: null, id: vm.client.impuestoaplId };
            selectChanged(vm.genericData.impuestos.list, vm.genericData.impuestos.selected);

            vm.genericData.tipoCobro.selected = { nombre: null, id: vm.client.clientepagaen };
            selectChanged(vm.genericData.tipoCobro.list, vm.genericData.tipoCobro.selected);
        }

        function setDates() {
            vm.dates.contrato = vm.client.fechacontrato && new Date(vm.client.fechacontrato);
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if (!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }


        // Try to find the selected element in the list using the id property
        // If requireId is false it will keep the name even when id is null
        function selectChanged(list, selected, requireId) {
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
                if (!requireId) { return; }
                selected.nombre = null;
                selected.id = null;
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                selected.nombre = find.nombre;
                selected.id = find.id;
            } else {
                selected.nombre = null;
                selected.id = null;
            }
        }

        function findByProperty(array, property, id) {
            if (array === null) { return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }

        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function resizableInput(el, factor) {
            var int = Number(factor) || 7.7;
            function resize() { el.style.width = ((el.value.length + 1) * int) + 'px'; }
            var e = 'keyup,keypress,focus,blur,change'.split(',');
            for (var i in e) { el.addEventListener(e[i], resize, false); }
            resize();
        }

        function resizable() {
            resizableInput(document.getElementById('txt'), 7);
        }

        vm.toggleVisibility = function (className) {

            var elements = document.getElementsByClassName(className);

            for (var i = 0; i < elements.length; i++) {
                var obj = elements[i];

                if (obj.classList.contains('none')) {
                    obj.classList.remove('none');
                } else {
                    obj.classList.add('none');
                }
            }
        }

        vm.conditionsCount = function () {
            var conditionsCnt = vm.andConditions.length + vm.orConditions.length;
            return conditionsCnt;
        };

        vm.conditionsCountHumanized = function () {
            var conditionsCnt = vm.andConditions.length + vm.orConditions.length;

            if (conditionsCnt == 0) {
                return '';
            } else {
                if (conditionsCnt > 1) {
                    return conditionsCnt + ' condiciones';
                } else {
                    return '1 condición';
                }
            }
        };

    }

})();
